import React from 'react';
import {useTranslation} from 'react-i18next';
import List from '../list/List';
import useShow from '../../hooks/useShow';
import {Lightning} from '../../assets/symbols/symbols/Symbols.css';
import {variableTexts} from '../../assets/objects/Variables';
import * as css from './VariableDropdown.css';

interface VariableDropdownProps {
    onInsertVariable: (variableKey: string) => void;
    defaultVariables: Record<string, string>;
    disabledVariables: Record<string, string>;
    eventType: string;
    dataCy?: string;
}

function VariableDropdown({
    onInsertVariable,
    defaultVariables,
    disabledVariables,
    eventType,
    dataCy = 'variables-dropdown'
}: VariableDropdownProps) {
    const {t} = useTranslation('variables');
    const {open, close, isOpen, showClass} = useShow();
    const variables = Object.entries(defaultVariables);
    
    const getItem = (variable: [string, string], disabled: boolean) => ({
        key: variable[0],
        value: variable[1],
        icon: Lightning,
        leftChildren: (
            <css.item>
                {(!!variableTexts[eventType] && t(variableTexts[eventType][variable[0]])) || t(variable[0])}
            </css.item>
        ),
        disabled: disabled
    });
    
    const variablesList = [
        ...variables
            .filter((variable) => variable[0] !== 'timeOpenstartText')
            .map((variable) => getItem(variable, false)),
        ...Object.entries(disabledVariables).map((variable) => getItem(variable as [string, string], true))
    ];
    
    const handleInsert = (key: string) => {
        const variable = variables.find((item) => item[0] === key);
        if(!variable) return;
        onInsertVariable(key);
        close();
    };

    return (
        <>
            <css.variableDropdown onClick={open} data-cy={dataCy}>
                {t('variables')}
            </css.variableDropdown>
            {!!isOpen && (
                <List
                    showClass={showClass}
                    close={close}
                    title={t('addVariables')}
                    height={300}
                    width={200}
                    left={'10px'}
                    top={10}
                    list={variablesList}
                    onClick={(item) => handleInsert(item.key)}
                />
            )}
        </>
    );
}

export default VariableDropdown;
